var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57575_18664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.65936 5.65936 0.5 12 0.5C18.3406 0.5 23.5 5.65936 23.5 12C23.5 18.3406 18.3406 23.5 12 23.5C5.65936 23.5 0.5 18.3406 0.5 12ZM1.34617 12C1.34617 17.8749 6.12501 22.6538 12 22.6538C17.875 22.6538 22.6538 17.875 22.6538 12C22.6538 6.12501 17.875 1.34617 12 1.34617C6.12501 1.34617 1.34617 6.12506 1.34617 12Z",
    fill: "#0D1526",
    stroke: "#12A8C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2705 8.27051L10.1539 14.387L7.72964 11.9628L6.42432 13.2682L10.1539 16.9978L17.5758 9.57588L16.2705 8.27051Z",
    fill: "#0D1526"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57575_18664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.11c46ce0c401e016c6d37121ec3a7a70.svg";
export { ForwardRef as ReactComponent };